<template lang="pug">

  div
    div( v-if="loading || $apollo.queries.batch.loading" ) Loading...
    div( v-else )
      
      MFlashMessages

      div( class="back-page" )
        router-link( v-bind:to="`/reporting/batches`" )
          i( class="fa fa-angle-left" )
          | &nbsp;Back to Your Results

      div( class="custom-title floating" )
        div( class="fleft" )
          h2( class="page-title" ) {{ batch.name || `Batch of ${batch.numLinks} link${batch.numLinks !== 1 ? 's' : ''}` }}
            span( v-if="$moonpull.currentUserIsSuperAdmin()" ) &nbsp;(&#35;{{ batch.id }})
          p( class="light-text" v-if="batch.description" ) {{ batch.description }}
          button( v-if="$moonpull.currentUserIsSuperAdmin() && batch.csv" class="btn btn-link p-0" v-on:click="downloadInputCsv" )
            MMoonpullIcon( class="mr-2" )
            | Download Input CSV
          button( v-if="$moonpull.currentUserIsSuperAdmin()" class="btn btn-link p-0 ml-2" v-on:click="downloadGeneratedInputCsv" )
            MMoonpullIcon( class="mr-2" )
            | Generate definitive input CSV
      
      div( class="wrapper wrapper-content" )
        div( class="row" v-if="! batch.isDone" )
          div( class="col-12" )
            div( class="alert alert-info" )
              i( class="fa fa-spinner fa-spin mr-2" )
              | This batch is still processing... ({{ batch.numCurrentCompletedAudits }}/{{ batch.numLinks }})
        
        div
          div( class="row")
            div(class="col-lg-3 d-flex align-items-stretch")
              div(class="ibox-content health-check w-100")
                h3 Memory Cookie Status Check

                h1( class="info-color font-bold")
                  | {{ batch.numCurrentCompletedAudits }}
                  small( style="font-size: 60%;" ) &nbsp;Processed Links
                
                label( v-if="$moonpull.currentUserIsSuperAdmin()" )
                  input( type="checkbox" class="mr-2" v-model="showOnlyPlatformResults" )
                  MMoonpullIcon( class="mr-2" )
                  | Show results on batch completion

                p( v-if="$moonpull.currentUserIsSuperAdmin() && batch.hasDuplicates && batch.isDone" )
                  MMoonpullIcon
                  button( class="btn btn-link" v-on:click="batchCleanup" ) Cleanup batch
                
                hr
                
                table
                  tr( v-for="status in memoryCookieStatusCounts" v-bind:key="status.memoryCookieStatus" )
                    td( class="status-blob" )
                      div( v-bind:class="`blob ${getColorForStatus(status.status)}`" )
                    td {{ status.statusReadable }}
                    td( class="no-wrap" ) {{ status.count }}

            div( class="col-lg-3 d-flex align-items-stretch" )
              div( class="ibox-content health-check w-100")
                h3 Using Moonpull
                div( class="issue-copy") {{ platformContent.issuesUsingMoonpull }}
            div( class="col-lg-3 d-flex align-items-stretch" )
              div( class="ibox-content health-check w-100")
                h3 Advertisers with changes since last audit
                div( class="issue-copy" ) {{ platformContent.issuesChangedStatus }}
                strong( class="info-color font-bold") Changed:  {{ changedCount }}
            div( class="col-lg-3 d-flex align-items-stretch" )
              div( class="ibox-content health-check w-100")
                h3 Advertisers with same memory status since last audit
                div( class="issue-copy" ) {{ platformContent.issuesSameStatus }}
                strong( class="info-color font-bold") The same, or no comparable: {{ totalCount - changedCount }}

          div( class="row mt-3" v-if="$moonpull.currentUserIsSuperAdmin() && batch && batch.name" )
            div( class="col-12" )
              div( class="ibox" )
                div( class="ibox-title" )
                  h3 Batch History Comparison
                div( class="ibox-content batch-history-comparison" v-if="!loadBatchHistory" )
                  button( class="btn btn-outline btn-info" v-on:click="loadBatchHistory = true" ) Load Batch History
                div( class="ibox-content batch-history-comparison" v-else-if="$apollo.queries.batchHistory.loading" )
                  i( class="fa fa-spinner fa-spin mr-2" )
                  | Loading batch history...
                div( class="ibox-content batch-history-comparison" v-else-if="!batchHistory || !batchHistory.length" )
                  | No previous batches found with the same name.
                div( class="ibox-content batch-history-comparison" v-else )
                  div( class="row align-items-start" )
                    div( class="col-md-4 mb-3" )
                      label( class="font-bold d-block mb-2" ) Compare with a previous batch:
                      select( class="form-control" v-model="selectedHistoricalBatchId" )
                        option( v-bind:value="null" ) Select a previous batch...
                        option( v-for="hBatch in batchHistory" v-bind:key="hBatch.id" v-bind:value="hBatch.id" )
                          | {{ dateFormat(hBatch.startedAt, 'yyyy-mm-dd HH:MM') }} ({{ hBatch.numLinks }} links)

                    div( class="col-md-8" v-if="selectedHistoricalBatchId && historicalBatchStatusCounts" )
                      table( class="table table-striped batch-comparison-table" )
                        thead
                          tr
                            th Status
                            th( class="text-right" ) Current
                            th( class="text-right" ) Previous
                            th( class="text-right" ) Change
                        tbody
                          tr( v-for="row in statusComparison" v-bind:key="row.status" )
                            td
                              span( class="d-inline-flex align-items-center" )
                                span( v-bind:class="`blob ${getColorForStatus(row.status)}`" class="mr-2" )
                                span {{ row.statusReadable }}
                            td( class="text-right" ) {{ row.current }}
                            td( class="text-right" ) {{ row.previous }}
                            td( class="text-right" )
                              span( v-if="row.delta !== 0" v-bind:class="getDeltaClass(row)" )
                                strong {{ row.delta > 0 ? '+' : '' }}{{ row.delta }}
                              span( v-else class="text-muted" ) -
                          tr( class="font-bold" )
                            td Total
                            td( class="text-right" ) {{ totalCount }}
                            td( class="text-right" ) {{ historicalTotalCount }}
                            td( class="text-right" )
                              span( v-if="totalCount - historicalTotalCount !== 0" )
                                | {{ totalCount - historicalTotalCount > 0 ? '+' : '' }}{{ totalCount - historicalTotalCount }}
                              span( v-else class="text-muted" ) -

          div( class="wrapper wrapper-content" )
    
            div( class="ibox mt-2" )
              div( class="ibox-title filter-title-bar" v-on:click.prevent="showFilter = ! showFilter" )
                h3 Advanced Search
                MRefreshQueryButton( v-bind:apollo-query="[ $apollo.queries.batch, $apollo.queries.audits ]" )
                div( class="ibox-tools" )
                  a( class="collapse-link" href="#" v-on:click.prevent="" )
                    i( class="fa" v-bind:class="{ 'fa-chevron-up': showFilter, 'fa-chevron-down': ! showFilter }" )
    
              div( class="ibox-content" v-bind:class="{ 'd-none': ! showFilter }" )
    
                div( class="row" )
                  div( class="col-12" )
                    div( class="form-group" )
                      label
                        strong Results per page
                      select( class="form-control" v-model="resultsPerPage" )
                        option( v-bind:value="10" ) 10
                        option( v-bind:value="25" ) 25
                        option( v-bind:value="50" ) 50
                        option( v-bind:value="100" ) 100
    
                div( class="row" )
                  div( class="col-12" )
                    div( class="form-group" )
                      label
                        strong View
                      div( class="input-group" )
                        div( class="btn-group" )
                          button( class="btn" v-bind:class="memoryCookieStatuses.length === 0 ? 'btn-primary' : 'btn-white'" v-on:click="handleFilter()" ) All
                          button( class="btn" v-bind:class="memoryCookieStatuses.includes('IMMEDIATE') ? 'btn-primary' : 'btn-white'" v-on:click="handleFilter('IMMEDIATE')" ) Immediate
                          button( class="btn" v-bind:class="memoryCookieStatuses.includes('CONDITIONAL_ON_CMP') ? 'btn-primary' : 'btn-white'" v-on:click="handleFilter('CONDITIONAL_ON_CMP')" ) User Consent
                          button( class="btn" v-bind:class="memoryCookieStatuses.includes('CONDITIONAL_ON_CMP_AND_REFRESH') ? 'btn-primary' : 'btn-white'" v-on:click="handleFilter('CONDITIONAL_ON_CMP_AND_REFRESH')" ) Page Refresh
                          button( class="btn" v-bind:class="memoryCookieStatuses.includes('NO_MEMORY_COOKIE') ? 'btn-primary' : 'btn-white'" v-on:click="handleFilter('NO_MEMORY_COOKIE')" ) No Cookie
                          button( class="btn" v-bind:class="memoryCookieStatuses.includes('MANUAL_REVIEW') ? 'btn-primary' : 'btn-white'" v-on:click="handleFilter('MANUAL_REVIEW')" ) MR
                          button( class="btn" v-bind:class="memoryCookieStatuses.includes('NOT_AUDITED') ? 'btn-primary' : 'btn-white'" v-on:click="handleFilter('NOT_AUDITED')" ) Not Audited
                          button( class="btn" v-bind:class="memoryCookieStatuses.includes('CLOSED_ADVERTISER') ? 'btn-primary' : 'btn-white'" v-on:click="handleFilter('CLOSED_ADVERTISER')" ) Closed
                          button( class="btn" v-bind:class="memoryCookieStatuses.includes('OTHER') ? 'btn-primary' : 'btn-white'" v-on:click="handleFilter('OTHER')" ) Other
                
                div( class="row" )
                  div( class="col-12" )
                    div( class="form-group" ) 
                      label
                        strong Memory Cookie Comparison
                      div( class="input-group" )
                        div( class="btn-group" )
                          button( class="btn" v-bind:class="view === 'CHANGED' ? 'btn-primary' : 'btn-white'" v-on:click="toggleChangedView" ) Changed
                
                div( class="row" v-if="$moonpull.currentUserIsSuperAdmin()" )
                  div( class="col-12" )
                    div( class="form-group" ) 
                      label
                        MMoonpullIcon( class="mr-2" )
                        strong AI Results
                      div( class="input-group" )
                        div( class="btn-group" )
                          button( class="btn" v-bind:class="showOnlyAuditsWithAiResults ? 'btn-primary' : 'btn-white'" v-on:click="showOnlyAuditsWithAiResults = !showOnlyAuditsWithAiResults" )
                            | Show only Audits with AI Results
    
                div( class="row" )
                  div( class="col-12" )
                    div( class="form-group" )
                      label
                        strong Filter results by advertiser or network
                      div( class="input-group" )
                        div( class="input-group-prepend" )
                          span( class="input-group-addon" )
                            i( class="fa fa-search" )
                        input( class="form-control" placeholder="Filter results" v-model="filterString" )
    
                div( class="row mt-4" )
                  div( class="col-md-3" )
                    strong Filter by Country
                    select( class="form-control" v-model="currentCountry" )
                      option( v-bind:value="null" ) All
                      option( v-for="country in countryCodes" v-bind:value="country.value" v-bind:disabled="country.disabled" ) {{ country.label }}
                
                div( class="row" v-if="$moonpull.currentUserIsSuperAdmin()" )
                  div( class="col-12" )
                    hr
                    div( class="form-group" )
                      label
                        MMoonpullIcon( class="mr-2" )
                        strong Moonpull Superuser Filters
                      
                      div( class="input-group mt-2" )
                        div( class="form-check abc-checkbox form-check-inline" )
                          label( class="form-check-label" )
                            input( class="form-check-input" type="checkbox" v-model="showOutdated" )
                            | Show outdated audits?
                      
                      div( class="input-group mt-2" )
                        div( class="form-check abc-checkbox form-check-inline" )
                          label( class="form-check-label" )
                            input( class="form-check-input" type="checkbox" v-model="cmpReview" )
                            | CMP review (shows audits where no CMP was detected)
                
                div( class="row" )
                  div( class="col-12 text-right" )
                    button( class="btn btn-secondary" v-on:click.prevent="showFilter = ! showFilter" ) Close
        
        div( class="ibox" v-if="$moonpull.currentUserIsSuperAdmin()" )
          div( class="ibox-content" )
            div( class="d-flex justify-content-between align-items-center" )
              div
                h3( class="m-0" ) AI Questions and Actions on Batch
              div( v-if="!batch.hasAiQuestionResults" )
                div( v-if="memoryCookieNotFoundCount === 0" )
                  | No relevant Audits for AI
                
                button( class="btn btn-primary" v-on:click="performAiQuestionsAndActions" v-bind:disabled="batch.isAiProcessing" v-else )
                  MMoonpullIcon( class="mr-2" )
                  span( v-if="batch.isAiProcessing" )
                    i( class="fa fa-spinner fa-spin mr-2" )
                    | AI is processing...
                  span( v-else ) Perform AI Questions and Actions
            
            div( class="alert alert-info mt-4" v-if="batch.hasAiQuestionResults && !batch.isAiProcessing" )
              div( class="d-flex justify-content-center align-items-center" )
                | AI Questions and Actions have been performed for this Batch
                button( class="btn btn-outline" v-on:click="showOnlyAuditsWithAiResults = true" ) View Results

            div( class="alert alert-info mt-4 text-center" v-if="batch.isAiProcessing" )
              | AI Questions and Actions are currently processing. Please check back later.
              div( class="progress" )
                div(
                  class="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  v-bind:class="{ 'progress-bar-success': aiQuestionPercentComplete < 100, 'progress-bar-primary': aiQuestionPercentComplete >= 100 }"
                  v-bind:style="`width: ${aiQuestionPercentComplete}%;`"
                  v-bind:aria-valuenow="aiQuestionPercentComplete"
                )

        div( class="ibox" )

          div( class="ibox-content" )
      
            div( class="col-md-12 d-flex justify-content-start mt-4 " )
              div(class="btn-group text-left")
                button( class="btn btn-details btn-outline btn-info" v-on:click="() => toggleDropdown1()" )
                  | Actions
                button( class="btn btn-details btn-outline btn-info" v-on:click="() => toggleDropdown1()" )
                  i( class="fa fa-caret-down " ) 
                ul( class="dropdown-menu" v-bind:class="showDropdown1 && 'show' " x-placement="bottom-start" )
                  li(v-if="$moonpull.currentUserHasAccessTo('geekFeatures')")
                    MModalButton(
                      v-bind:button-text="'Assign'"
                      title="You are assigning some Moonpull links to the user"
                      button-classes="dropdown-item"
                      modal-size="modal-lg"
                    )
                      div( slot="body" )
                        MUserSelector( v-model="userId" )
                        button( class="btn btn-details btn-outline btn-info mt-4" v-on:click="auditUpdateMany") Assign Links To This User
                  
                  li(v-if="$moonpull.currentUserHasAccessTo('geekFeatures')")
                    MModalButton(
                      v-bind:button-text="'Assign and notify.'"
                      title="You are assigning some Moonpull links with a notification to the user"
                      button-classes="dropdown-item"
                      modal-size="modal-lg"
                      v-if="$moonpull.currentUserHasAccessTo('geekFeatures')"
                    )
                      div( slot="body" )
                        MUserSelector( v-model="userId" )
                        button( class="btn btn-details btn-outline btn-info mt-4" v-on:click="assignNotify") Assign links to this user, with email notification.


                  li
                    MModalButton(
                      v-if="$moonpull.currentUserIsSuperAdmin()"
                      v-bind:button-text="'Assign and notify with details.'"
                      title="You are assigning some Moonpull links with a notification to the user"
                      button-classes="dropdown-item"
                      modal-size="modal-lg"
                    )
                      div( slot="body" )
                        MUserSelector( v-model="userId" )
                        button( class="btn btn-details btn-outline btn-info mt-4" v-on:click="notifyDetails") Assign links to this user, with email notification.

                  li
                    MModalButton(
                      v-bind:title="`Add ${auditIds.length} link${(auditIds.length === 1) ? '' : 's'} to a schedule template`"
                      button-classes="dropdown-item"
                      modal-size="modal-lg"
                    )
                      span( slot="button-inner" ) Add to existing schedule template
                      div( slot="body" )
                        p( v-if="auditIds.length === 0" ) No links selected. Please select links using the checkbox at the end of the row.
                        div( v-else )
                          apollo-query( v-bind:query="templateBatchesQuery" )
                            template( v-slot="{ result: { loading, error, data } }" )
                              div( v-if="loading" ) Loading...
                              div( v-else-if="error" ) {{ error }}
                              div( v-else-if="data" )
                                div( v-if="data.batchMany.items.length === 0" )
                                  p You have no templates to add links to.
                                  p
                                    router-link( to="/scheduling" ) Manage templates
                                
                                div( v-else )
                                  label Select template:
                                    select( class="form-control" v-model="templateBatchId" )
                                      option( v-bind:value="null" ) Please select
                                      option( v-for="batch in data.batchMany.items" v-bind:value="batch.id" ) {{ batch.name }}
                            
                                  p( class="text-right" )
                                    button( class="btn btn-primary" v-on:click="addLinksToTemplateBatch" v-bind:disabled="addingLinksToTemplate" )
                                      MLoadingSpinner( class="mr-2" v-if="addingLinksToTemplate" )
                                      | Add Links

            template
              table( class="table table-striped" )
                thead
                  tr
                    th 
                    th Advertiser
                    th Network
                    th Memory Cookie Status
                      p Network Script Presence
                    th Consent
                      br
                      span Platform
                      br
                      span Detected
                    th
                      MModalButton( button-classes="btn-link font-bold" modal-size="modal-lg" title="Audit Details" )
                        span( slot="button-inner" )
                          | Details
                          i( class="fa fa-question inline-block ml-2" )
                        p( slot="body" class="text-left font-normal" )
                          strong Details
                          ul
                            li Country - The country used for testing the link (specified by user or default of GB used).
                            li CMP - The CMP identified by Moonpull 
                            li ATM - Advertiser Tracking Method narrative (as uploaded to the 'Network Provided Information' e.g. by a network employee)
                            li Shopify Detected - Indicates for an audit with critical issues that the advertiser is hosted on Shopify.
                            li MR - means the link should be manually appraised as Moonpull found a matter it couldn't easily categorise.
                          strong Cookies Details
                          ul
                            li 1 or 3 indicates a ANI or wildcard cookie
                            li The text is the cookie name
                            li If 'User' appears it means the cookie details were specified by the user in the upload process.
                    th Memory Cookie Comparison
                      
                    th More
                
                tbody
                  
                  template( v-if="loadingAudits" )
                    tr( v-for="n in resultsPerPage" )
                      td( colspan="12" class="text-center" ) Loading...

                  tr( v-else-if="audits.items.length === 0" )
                    td( colspan="12" class="text-center" ) No links to display
                  
                  template( v-else )
                    tr(
                      v-for="audit in audits.items"
                      v-bind:key="audit.id"
                      v-bind:class="{ 'outdated': audit.outdated }"
                    )
                      template( v-if="audit.status === 'PROCESSING'" )
                        td( colspan="12" class="text-center font-weight-bold" )
                          i( class="fa fa-spinner fa-spin mr-2" )
                          em Currently Processing:&nbsp;
                          | {{ audit.link }}
                          | &nbsp;
                          i(
                            v-if="$moonpull.currentUserIsSuperAdmin()"
                            class="fa fa-trash"
                            v-bind:class="{ 'text-danger': ! awaitingSingleRerun, 'd-none': awaitingSingleRerun }"
                            style="cursor:pointer"
                            v-on:click="softDeleteAudit(audit)"
                          )
                      
                      template( v-else-if="audit.status === 'FAILED' && audit.noAccess" )
                        td( colspan="12" class="text-center" )
                          em {{ audit.link }}
                          br
                          | Your company does not have access to {{ audit.network }} links. Please contact your account manager to gain access.

                      template( v-else )
                        td
                          div( class="form-check" )
                            input( class="icheckbox_square-green" type="checkbox" v-bind:value="audit.id" v-model="auditIds")

                        td
                          MInternalAdvertiserIssue(
                            v-if="$moonpull.currentUserIsSuperAdmin() && audit.advertiser"
                            v-bind:advertiser-name="audit.advertiser.name"
                            v-bind:advertiser-id="audit.advertiser.id"
                            v-bind:reference-audit-id="audit.id"
                            v-bind:reference-audit-screenshots="audit.screenshots"
                            v-bind:button-text="getAdvertiserNameFromAudit(audit)"
                          )

                          span( v-else ) {{ getAdvertiserNameFromAudit(audit) }}
                          
                          div( v-if="$moonpull.currentUserHasAccessTo('whitelisting')" )
                            div( v-if="audit.injectedResult" )
                              MWhitelistContact(v-bind:audit="audit" v-if="shouldShowWhitelist(audit)")
                        
                        td {{ audit.network || audit.userDefinedNetwork || 'null' }}

                        td
                          MMemoryCookieStatusBadges(:audit="audit")
                          div(v-if="audit.liteResult")
                            | Network Script: 
                            span {{ audit.liteResult.masterTagAlp ? 'OK' : 'N' }}
                            template(v-if="audit.liteResult.cmp")
                              span &nbsp;{{ audit.liteResult.masterTagAlpPostConsent ? 'OK' : 'N' }}
                              span &nbsp;{{ audit.liteResult.masterTagAlpPostConsentRefresh ? 'OK' : 'N' }}

                          div( v-if="! audit.injectedResult && ! audit.enhancedMemoryCookieStatuses.length && ! audit.liteResult" )
                            span( v-if="getTrackingMatrix(audit)" ) Network Script:&nbsp;
                            span(v-html="getTrackingMatrix(audit)")

                        td
                          MModalButton(
                            v-bind:title="auditHasCmp(audit) ? 'CMP Detected' : 'No CMP Detected'"
                            modal-size="modal-xl"
                            button-classes="m-0"
                          )
                            div( slot="button-inner" class="m-0" )
                              | {{ auditHasCmp(audit) ? 'Yes' : 'No' }}
                            
                            div( slot="body")
                              div( class="row" v-if="$moonpull.currentUserCompanyIs('Awin')" )
                                div( class="col-sm-9" )
                                  h3( class="text-left" ) Platform
                                  div( class="row" )
                                    div( class="col-6" )
                                      img(
                                        class="w-100 screenshot"
                                        v-bind:src="audit && audit.screenshots && audit.screenshots[0] && generateScreenshotUrl(audit.screenshots[0].screenshotUrl)"
                                        alt="Not found"
                                      )
                                    
                                    div( class="col-6" )
                                      img(
                                        class="w-100 screenshot"
                                        v-bind:src="audit && audit.screenshots && audit.screenshots[1] && generateScreenshotUrl(audit.screenshots[1].screenshotUrl)"
                                        alt="Not found"
                                      )

                                  h3( class="text-left mt-4" ) Lite
                                  div( class="row" )
                                    div( class="col-6" )
                                      p ALP
                                      img(
                                        class="w-100"
                                        v-bind:src="`https://moonpull-serverless-results.s3.amazonaws.com/screenshots/${audit.id}-alp.png`"
                                        alt="Not found"
                                      )
                                    
                                    div( class="col-6" )
                                      p Post Consent
                                      img(
                                        class="w-100"
                                        v-bind:src="`https://moonpull-serverless-results.s3.amazonaws.com/screenshots/${audit.id}-post-consent.png`"
                                        alt="Not found"
                                      )
                                
                                div( class="col-sm-3 text-left" )
                                  MCookieMetadata(
                                    v-bind:audit-id="audit.id"
                                    v-bind:audit-link="audit.link"
                                    v-bind:batch-cmp-metadata="batch.cmpMetadata"
                                  )
                              div( class="row" v-else )
                                div( class="col-sm-12" )
                                  h3( class="text-left" ) Platform
                                  img( class="w-100" v-bind:src="audit && audit.screenshots && audit.screenshots[0] && generateScreenshotUrl(audit.screenshots[0].screenshotUrl)" class="screenshot" )

                                  h3( class="text-left mt-4" ) Lite
                                  img( class="w-100" v-bind:src="`https://moonpull-serverless-results.s3.amazonaws.com/screenshots/${audit.id}-alp.png`" alt="Not found" )
                          
                        td
                          MAuditBadges( v-bind:audit="audit" column center )
                        td
                          span Most Recent:&nbsp;
                            span( v-if="audit.previousComparisonAudit" )
                              router-link( v-bind:to="`/reporting/audits/${audit.previousComparisonAudit.id}/output-report`" target="_blank" )
                                | {{ dateFormat(audit.previousComparisonAudit.auditedAt, 'yyyy-mm-dd') }}
                                i( class="fa fa-external-link ml-2" )
                              span {{ (audit.isChangedFromComparison && ' Different') || ' Same' }}
                            span( v-else ) No previous running

                          br
                          span Next:&nbsp;
                            span( v-if="audit.nextComparisonAudit" ) 
                              router-link( v-bind:to="`/reporting/audits/${audit.nextComparisonAudit.id}/output-report`" target="_blank" )
                                | {{ dateFormat(audit.nextComparisonAudit.auditedAt, 'yyyy-mm-dd') }}
                                i( class="fa fa-external-link ml-2" )
                              span {{ (audit.nextComparisonAudit && audit.nextComparisonAudit.isChangedFromComparison && ' Different') || ' Same' }}
                            span( v-else ) No next running
                        td
                          div( class="btn-group" )
                            router-link(
                              v-bind:to="auditLink(audit)"
                              class="btn btn-details btn-outline btn-info"
                            ) View Audit
                            
                            button( class="btn btn-details btn-outline btn-info" v-on:click.stop="() => toggleDropdown(audit)" )
                              i( class="fa fa-caret-down" )

                            ul( class="dropdown-menu" v-bind:class="audit.showDropdown && 'show'" x-placement="bottom-start" v-on:click.stop="() => false" )

                              li
                                a( class="dropdown-item" target="_blank" v-bind:href="audit.link" )
                                  | Open affiliate link&nbsp;
                                  i( class="fa fa-external-link" )
                              
                              li
                                router-link( class="dropdown-item" target="_blank" v-bind:to="`/reporting/audits/${audit.id}/technical-report`" )
                                  | Technical Report&nbsp;
                                  i( class="fa fa-external-link" )

                              li
                                MModalButton(
                                  v-bind:button-text="audit.clientComment ? 'Edit Comment' : 'Add Comment'"
                                  title="Add/Edit Comment"
                                  button-classes="dropdown-item"
                                  modal-size="modal-xl"
                                )
                                  textarea(
                                    slot="body"
                                    class="form-control"
                                    placeholder="Add a comment to this link"
                                    rows="10"
                                    v-model="audit.clientComment"
                                  )
                                  div( slot="footer" class="text-right" )
                                    button( class="btn btn-success" v-on:click="addComment(audit)" ) Save comment                                

                              li( v-if="$moonpull.currentUserIsSuperAdmin()" )
                                MModalButton(
                                  title="Move audit to a different batch"
                                  button-classes="dropdown-item"
                                  modal-size="modal-lg"
                                  @click="openMoveAuditModal"
                                )
                                  span( slot="button-inner" )
                                    MMoonpullIcon( class="mr-2" )
                                    | Move

                                  div( slot="body" )
                                    apollo-query( v-bind:query="getBatchesForBatchMoveDropdown" )
                                      template( v-slot="{ result: { loading, error, data } }" )
                                        span( v-if="loading" ) Loading batches...
                                        template( v-else-if="data" )
                                          select( v-model="selectedMoveBatch" )
                                            option( v-bind:value="null" ) Please select a batch...
                                            option( v-for="batch in data.batchMany.items" v-bind:value="batch.id" )
                                              | [{{ dateFormat(batch.startedAt, 'yyyy-mm-dd HH:MM') }}] {{ batch.name }} {{ batch.description }}
                                      template
                                        input(
                                          type="text"
                                          v-model="batchFilterString"
                                          placeholder="Filter batches..."
                                          @input="updateFilterString($event.target.value)"
                                          class="mt-4 mr-4"
                                        )

                                        select(v-model="selectedMoveBatch")
                                          option(disabled value="") Please select a batch...
                                          option(v-for="batch in batches.items" :key="batch.id" :value="batch.id")
                                            | {{ batch.name }}



                                  div( slot="footer" class="text-right" )
                                    button( class="btn btn-success" v-on:click="moveAuditAndBatchLink(audit)" v-bind:disabled="movingAudit" )
                                      MLoadingSpinner( v-if="movingAudit" class="mr-2" )
                                      | Move Audit

                              li( v-if="$moonpull.currentUserIsSuperAdmin()" )
                                a( class="dropdown-item" href="#" v-on:click.prevent="deleteAuditAndBatchLink(audit)" )
                                  MMoonpullIcon( class="mr-2" )
                                  | Delete

                              li( v-if="$moonpull.currentUserIsSuperAdmin()" )
                                a( v-if="! audit.outdated" class="dropdown-item" href="#" v-on:click.prevent="rerunAudit(audit)" v-bind:disabled="awaitingSingleRerun" )
                                  MMoonpullIcon( class="mr-2" )
                                  | Rerun
                              
                              li( v-if="$moonpull.currentUserIsSuperAdmin()" )
                                MModalButton(
                                  title="AI Results"
                                  button-classes="dropdown-item"
                                  modal-size="modal-xl"
                                )
                                  span( slot="button-inner" )
                                    MMoonpullIcon( class="mr-2" )
                                    | AI Questions

                                  div( slot="body" )
                                    MAuditAiInteractions( v-bind:audit="audit" )

                    tr( v-if="! batch.isDone" )
                      td( colspan="12" class="text-center" )
                        i( class="fa fa-spinner fa-spin mr-2" )
                        em {{ batch.numLinks - batch.numCurrentCompletedAudits }} links are queued. They will appear here as they finish processing.
        
        div( class="row" )
          div( class="col-12 text-right" )
            p Page {{ currentPage }} of {{ (audits && audits.pageInfo && audits.pageInfo.pageCount) || '...' }}
            div( class="btn-group" )
              button( class="btn btn-white" v-bind:disabled="loadingAudits || ! audits.pageInfo.hasPreviousPage" v-on:click="() => currentPage = Math.max(currentPage - 1, 1)" ) Prev page
              button( class="btn btn-white" v-bind:disabled="loadingAudits || ! audits.pageInfo.hasNextPage" v-on:click="() => currentPage += 1" ) Next page

        .btn-group.pagingation.d-none
            button.btn.btn-white
              i.fa.fa-chevron-left
            button.btn.btn-primary 1
            button.btn.btn-white 2
            button.btn.btn-white 3
            button.btn.btn-white 4
            button.btn.btn-white ...
            button.btn.btn-white 206
            button.btn.btn-white
              i.fa.fa-chevron-right

    div( class="cleaning-up-overlay" v-if="cleaningUp" )
      i( class="fa fa-spinner fa-spin" )

</template>

<style lang="scss">
table.analysis-table {
  tr {
    th, td {
      text-align: left !important;
    }
  }
}

.analysis-response {
  white-space: break-spaces;
}

.value-calculator .modal-content,
.value-calculator-success .modal-content {
  border-radius: 20px;
}
.value-calculator .inmodal .modal-header,
.value-calculator-success .inmodal .modal-header {
  text-align: left;
  border-bottom: 0;
  padding: 20px 30px 0px 30px;
}
.value-calculator .inmodal .modal-body,
.value-calculator-success .inmodal .modal-body {
  font-size: 14px;
  background: #fff;
  border-radius: 0 0 20px 20px;
  overflow-y: visible !important;
}
.value-calculator .inmodal .modal-footer,
.value-calculator-success .inmodal .modal-footer {
  display: none;
}
.value-calculator .inmodal .modal-body button {
  width: 150px;
}
.value-calculator .inmodal .modal-body span {
  color: #6f6f6f;
}
.value-calculator .inmodal .modal-body span.result {
  color: #234;
  font-size: 16px;
}
.value-calculator .inmodal .modal-body input {
  font-size: 16px;
  padding: 3px 6px;
  width: 100px;
  border: 1px solid #dddddd;
}
.value-calculator .modal-title {
  color: #b54708;
  padding: 5px 10px;
  display: inline-block;
  background: #fffaeb;
  border-radius: 5px;
  font-size: 16px !important;
}
.value-calculator-success .modal-title {
  color: #027a48;
  background: #f6fef9;
  padding: 5px 10px;
  display: inline-block;
  border-radius: 5px;
  font-size: 16px !important;
}

.cleaning-up-overlay {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);

  .fa-spinner {
    font-size: 4em;
    color: white;
  }
}

.strikethrough {
  text-decoration: line-through;
}
</style>

<style lang="scss">
.table-list {
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
.status-cell {
  vertical-align: middle;
}
.btn-details {
  margin-bottom: 0 !important;
}
td {
  word-break: break-all;
}
.actions-col {
  width: 180px;
}
.screenshot {
  max-width: 100%;
}
.screenshot-thumbnail {
  width: 200px;
  height: 200px;
}
.issue-copy {
  white-space: pre-line;
}
.details-col {
  width: 240px;
}
tbody tr.outdated {
  td:first-child {
    position: relative;

    &::before {
      content: "";

      display: block;
      width: 5px;
      height: 102%;

      position: absolute;
      top: 0;
      left: 15px;

      background-color: #0c2556;
    }
  }
}
.health-check {
  table {
    tr {
      td.no-wrap {
        text-wrap: nowrap;
      }
      &.health-check-sub {
        td {
          font-size: 0.9em;
        }
      }
    }
  }
}
.filter-title-bar {
  cursor: pointer;
}
.batch-comparison-table {
  th {
    font-size: 0.85em;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #676a6c;
    border-top: none;
  }
  td {
    vertical-align: middle;
    word-break: normal;
  }
  .blob {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
  }
  .delta-positive {
    color: #1ab394;
  }
  .delta-negative {
    color: #ed5565;
  }
}
ul.dropdown-menu {
  left: -130px;
}
</style>

<script>
import Vue from "vue";
import * as dateFormat from "dateformat";
import gql from "graphql-tag";
import { countryCodes } from "@/countryCodes";
import { api } from "@/api";
export default Vue.extend({
  props: ["audit"],

  data() {
    return {
      URL,
      loading: true,
      breadcrumbs: [
        { label: "Home", link: "/" },
        { label: "Reporting", link: "/reporting" },
        { label: "Your Results", link: "/reporting/batches" },
        {
          label: `#${this.$route.params.batchId.substr(-4)}`,
          link: `/reporting/batches/${this.$route.params.batchId}`,
        },
      ],
      filterString: "",
      filterUser: "",
      filterStatus: "",
      view: null,
      batchView: "customer",
      showOutdated: false,
      cmpReview: false,
      networks: null,
      awaitingSingleRerun: false,
      currentStatuses: [],
      currentUser: this.$route.query.user || null,
      currentCountry: null,
      countryCodes,
      typeOfStatus: this.$route.query.status || null,
      showFilter: false,
      resultsPerPage: 25,
      currentPage: 1,
      showDropdown1: false,
      userId: null,
      auditIds: [],
      company: this.$moonpull.getCurrentUserSession().company.name,
      name: this.$moonpull.getCurrentUserSession().name,
      email: this.$moonpull.getCurrentUserSession().email,
      batchurl: this.$route.params.batchId,
      templateBatchId: null,
      addingLinksToTemplate: false,
      selectedMoveBatch: null,
      batchFilterString: "",
      selectedBatch: null,
      debounceTimer: null,
      isModalOpen: false,
      movingAudit: false,
      currencySymbol: "",
      avgBasket: "",
      monthlyTrackedSales: "",
      aveCommission: null,
      proportionOfUsers: null,
      proportionConsent: null,
      monthlySalesValue: null,
      commissionPayable: null,
      improvedMonthlySalesValue: null,
      overalImprovement: null,
      improvedCommission: null,
      advertiserThirdParty: false,
      proportionOfUsers: 70,
      proportionConsent: 50,
      monthlySalesValue: null,
      proportionConsentCalc2: "N/A",
      estimateImprovment1: null,
      estimateImprovement2: null,
      cleaningUp: false,
      memoryCookieStatusCounts: [],
      memoryCookieStatuses: [],
      isAuditChanged: false,
      changedCount: 0,
      showOnlyPlatformResults: false,
      showOnlyAuditsWithAiResults: false,
      liteScripts: {},
      aiQuestionProgressPollHandle: null,
      aiQuestionNumAudits: null,
      aiQuestionNumCompleted: null,
      selectedHistoricalBatchId: null,
      historicalBatchStatusCounts: null,
      loadBatchHistory: false,
    };
  },

  watch: {
    resultsPerPage() {
      this.currentPage = 1;
    },
    showOutdated() {
      this.currentPage = 1;
    },
    view() {
      this.currentPage = 1;
    },
    filterString() {
      this.currentPage = 1;
    },
    currentStatuses() {
      this.currentPage = 1;
    },
    typeOfStatus() {
      this.currentPage = 1;
    },
    currentUser() {
      this.currentPage = 1;
    },
    selectedHistoricalBatchId(batchId) {
      if (batchId) {
        this.fetchHistoricalBatchStatusCounts(batchId);
      } else {
        this.historicalBatchStatusCounts = null;
      }
    },
    showOnlyPlatformResults() {
      if (this.selectedHistoricalBatchId) {
        this.fetchHistoricalBatchStatusCounts(this.selectedHistoricalBatchId);
      }
    },

    // Load AI Question progress for the batch if it's in progress
    batch(batch) {
      if (batch && batch.isAiProcessing && !this.aiQuestionProgressPollHandle) {
        console.log(`Polling for AI Question progress`, batch.id)
        this.aiQuestionProgressPollHandle = setInterval(async () => {
          const { data: { aiQuestionProgress } } = await this.$apollo.query({
            query: gql`
              query AiQuestionProgress($batchId: ID!) {
                aiQuestionProgress(batchId: $batchId)
              }
            `,
            variables: {
              batchId: batch.id,
            },
          })
          batch.isAiProcessing = aiQuestionProgress.isAiProcessing
          this.aiQuestionNumAudits = aiQuestionProgress.numAudits
          this.aiQuestionNumCompleted = aiQuestionProgress.numQuestionsCompleted
          console.log(`aiQuestionProgress`, aiQuestionProgress)

          if (!batch.isAiProcessing) {
            clearInterval(this.aiQuestionProgressPollHandle)
          }
        }, 10000)
      }
    },
  },

  apollo: {
    batchHealthCheck: {
      query: gql`
        query($batch: ID!) {
          batchHealthCheck(batch: $batch) {
            total
            batchLinkTotal
            healthy
            healthyNoCmp
            healthyFpCookieWithCmp
            critical
            healthyAfterAcceptAll
            advertiserWithIssues
            warning
            manualReview
            shopifyDetected
            processFailed
            healthyNoCmpNoError
            isHealthyWithFPCookieAndCMPNoError
            isHealthyAfterAcceptAllNoError
            healthyNoCmpError
            isHealthyWithFPCookieAndCMPError
            isHealthyAfterAcceptAllError
          }
        }
      `,
      variables() {
        return {
          batch: this.$route.params.batchId,
        };
      },
    },
    batches: {
      query: gql`
        query BatchPaginated($batchFilterString: String) {
          batchMany(
            sort: { startedAt: DESC }
            batchFilterString: $batchFilterString
          ) {
            count
            items {
              id
              name
              description
              startedAt
            }
          }
        }
      `,
      variables() {
        return {
          batchFilterString: this.batchFilterString,
        };
      },
      update: (data) => {
        const batches = data.batchMany;
        batches.items.forEach((b) => (b.dropdownToggle = false));
        return batches;
      },
      debounce: 500,
    },

    memoryCookieStatusCounts: {
      query: gql`
        query MemoryCookieStatusCounts(
          $batchId: ID!
          $countPlatformResultsOnly: Boolean!
        ) {
          memoryCookieStatusCounts(
            batchId: $batchId
            countPlatformResultsOnly: $countPlatformResultsOnly
          ) {
            status
            statusReadable
            count
          }
        }
      `,
      variables() {
        return {
          batchId: this.$route.params.batchId,
          countPlatformResultsOnly: this.showOnlyPlatformResults,
        };
      },
      fetchPolicy: "cache-first",
    },

    batchHistory: {
      query: gql`
        query BatchHistory($batchFilterString: String) {
          batchMany(
            sort: { startedAt: DESC }
            batchFilterString: $batchFilterString
          ) {
            items {
              id
              name
              startedAt
              numLinks
            }
          }
        }
      `,
      variables() {
        return {
          batchFilterString: this.batch?.name,
        };
      },
      skip() {
        return !this.batch?.name || !this.loadBatchHistory;
      },
      update(data) {
        return data.batchMany.items.filter(
          b => b.id !== this.$route.params.batchId && b.name === this.batch?.name
        );
      },
    },

    batch: {
      query: gql`
        query($batchId: ID!) {
          batchById(id: $batchId) {
            id
            owner {
              email
              company {
                name
              }
            }
            name
            description
            csv
            generatedInputCsv
            startedAt
            finishedAt
            numLinks
            numCurrentCompletedAudits
            isDone
            hasDuplicates
            cmpMetadata {
              id
              auditId
              hasCmp
              hasAcceptAll
              hasManage
              hasDecline
              hasComplex
              hasOther
              isForced
              size
              placement
              conclusion
              comment
              createdById
            }
            isAiProcessing
            hasAiQuestionResults
          }
        }
      `,

      variables() {
        return {
          batchId: this.$route.params.batchId,
        };
      },

      update: (data) => data.batchById,
    },

    audits: {
      query: gql`
        query AuditsForBatch(
          $batchId: ID
          $page: Float!
          $perPage: Float!
          $showOutdated: Boolean
          $cmpReview: Boolean
          $view: AuditForBatchView
          $queryString: String
          $userId: ID
          $statusType: StatusType
          $statuses: [ID!]
          $countryCode: String
          $memoryCookieStatuses: [String!]
          $platformResultsOnly: Boolean
          $showOnlyAuditsWithAiResults: Boolean
        ) {
          auditsForBatch(
            batchId: $batchId
            page: $page
            perPage: $perPage
            showOutdated: $showOutdated
            cmpReview: $cmpReview
            view: $view
            queryString: $queryString
            userId: $userId
            statusType: $statusType
            statuses: $statuses
            countryCode: $countryCode
            memoryCookieStatuses: $memoryCookieStatuses
            platformResultsOnly: $platformResultsOnly
            showOnlyAuditsWithAiResults: $showOnlyAuditsWithAiResults
          ) {
            pageInfo {
              currentPage
              perPage
              pageCount
              itemCount
              hasNextPage
              hasPreviousPage
            }
            items {
              id
              batch {
                id
                owner {
                  email
                  company {
                    name
                  }
                }
                name
                description
                csv
                startedAt
                finishedAt
                numLinks
                numCurrentCompletedAudits
                isDone
              }
              awsInstanceId
              order
              status
              assessmentStatus {
                id
                narrative
                statusType
              }
              assignedTo {
                id
                name
              }
              link
              name
              proxy
              placement
              userDefinedNetwork
              userDefinedMerchant
              detectedCmpId
              detectedCmp {
                name
              }
              cmpVendor
              tags
              failReason
              auditTime
              auditedAt
              network
              advertiser {
                id
                networkId
                advertiserId
                name
                domain
                primaryTrackingMethod
                trackingMethodNarrative
                javascript
                s2s
                other
                bespokeCookieValueType
                bespokeCookieName
                bespokeCookieValue
                bespokeAni
                bespokeMasterTag
                internalComment
                publicComment
                cannotAudit
                cannotAuditReason
                whitelistRequest {
                  id
                  whitelistActive
                  whitelistSent
                }
              }
              advertiserSnapshot
              inferredNetworkVariables
              moonpullErrors
              cookiesWereAccepted
              internalErrorObj
              handoverImpact
              handoverImpactPostConsent
              handoverImpactPostConsentRefresh
              hasPostConsentJourney
              hasPostConsentRefreshJourney
              closedMerchant
              outdated
              inferredS2S
              finalDomain
              csvOverrideCookieType
              csvOverrideCookieName
              csvOverrideCookieValue
              csvOverrideAni
              csvOverrideMasterTag
              aniTruncated
              interstitialNavigated
              noAccess
              proxyDetails
              manualReviewRequired
              hasAlp
              hasAlpPostConsent
              hasAlpPostConsentRefresh
              isRetry
              webUnlockerRequestId
              useDataCentre
              countryCode
              batchLink {
                postAlpURL
                skipConsent
                puppeteerFlags
              }
              isChangedFromComparison
              nextComparisonAudit {
                id
                auditedAt
                memoryCookieStatus
                isChangedFromComparison
              }
              previousComparisonAudit {
                id
                auditedAt
                memoryCookieStatus
                isChangedFromComparison
              }
              localComment
              screenshots {
                stage
                byteSize
                screenshotUrl
                createdAt
              }
              memoryCookieStatus
              memoryCookieStatusReadable
              enhancedMemoryCookieStatuses {
                status
                statusReadable
                source
                sourceReadable
                createdAt
                updatedAt
              }
              injectedResult {
                id
                createdAt
                template {
                  method
                  methodComment
                  status
                  publisherType
                  cookieName
                  cookieValue
                  cookieExpiry
                  landingPageType
                  readableStatus
                }
              }
              siteAppAssociations
              liteResult
              aiQuestionResults {
                id
                questionId
                aiResponse
                story
                actionTaken
                createdAt
              }
            }
          }
        }
      `,

      variables() {
        return {
          batchId: this.$route.params.batchId,
          page: this.currentPage,
          perPage: this.resultsPerPage,
          showOutdated: this.showOutdated,
          cmpReview: this.cmpReview,
          view: this.view,
          queryString: this.filterString,
          userId: this.currentUser,
          statusType: this.typeOfStatus,
          statuses: this.currentStatuses,
          countryCode: this.currentCountry ? this.currentCountry : null,
          memoryCookieStatuses: this.memoryCookieStatuses,
          platformResultsOnly: this.showOnlyPlatformResults,
          showOnlyAuditsWithAiResults: this.showOnlyAuditsWithAiResults,
        };
      },

      update(data) {
        this.awaitingSingleRerun = false;
        return data.auditsForBatch;
      },

      // When all audits are loaded
      async result({ data }) {
        if (!data) return;

        // Convert link to URL object
        for (let i = 0; i < data.auditsForBatch.items.length; i++) {
          const audit = data.auditsForBatch.items[i];
          try {
            audit.linkURLObj = new URL(audit.link);
          } catch (e) {}
        }

        // Add event listener to close dropdowns when they're not clicked
        window.addEventListener("click", () => {
          this.audits.items.forEach((a) => (a.showDropdown = false));
          this.audits.items = [...this.audits.items];
        });
      },

      debounce: 500,
    },

    dataCentres: {
      query: gql`
        query WhitelistingDataCentres {
          whitelistingDataCentres {
            code
            label
            ipAddress
          }
        }
      `,
      update: (data) => data.whitelistingDataCentres,
    },
  },

  computed: {
    loadingAudits() {
      return (
        this.$apollo.queries.audits.loading ||
        !this.batch ||
        !this.audits ||
        !this.audits.items
      );
    },
    totalCount() {
      return this.memoryCookieStatusCounts.reduce(
        (sum, status) => sum + status.count,
        0
      );
    },
    aiQuestionPercentComplete() {
      return Math.floor((this.aiQuestionNumCompleted / this.aiQuestionNumAudits) * 100.0)
    },
    memoryCookieNotFoundCount() {
      return this.memoryCookieStatusCounts?.find(m => m.status === 'NO_MEMORY_COOKIE')?.count || 0
    },
    historicalTotalCount() {
      if (!this.historicalBatchStatusCounts) return 0;
      return this.historicalBatchStatusCounts.reduce((sum, s) => sum + s.count, 0);
    },
    statusComparison() {
      if (!this.memoryCookieStatusCounts || !this.historicalBatchStatusCounts) return [];
      const allStatuses = new Set([
        ...this.memoryCookieStatusCounts.map(s => s.status),
        ...this.historicalBatchStatusCounts.map(s => s.status),
      ]);
      return Array.from(allStatuses).map(status => {
        const current = this.memoryCookieStatusCounts.find(s => s.status === status);
        const previous = this.historicalBatchStatusCounts.find(s => s.status === status);
        return {
          status,
          statusReadable: current?.statusReadable || previous?.statusReadable || status,
          current: current?.count || 0,
          previous: previous?.count || 0,
          delta: (current?.count || 0) - (previous?.count || 0),
        };
      });
    },
  },

  methods: {
    dateFormat,

    getAdvertiserNameFromAudit(audit) {
      if (audit.userDefinedMerchant) {
        if (audit.closedMerchant) {
          return `${audit.userDefinedMerchant} (Closed Advertiser)`;
        }
        return audit.userDefinedMerchant;
      } else if (audit.advertiserSnapshot && audit.advertiserSnapshot.name) {
        return audit.advertiserSnapshot.name;
      } else if (audit.finalDomain) {
        return audit.finalDomain;
      } else {
        return "None";
      }
    },

    async assignNotify() {
      this.$apollo.mutate({
        mutation: gql`
          mutation UpdateManyAudit($auditIds: [ID!], $userId: ID) {
            auditUpdateMany(
              filter: { id: { in: $auditIds } }
              record: { assignedToId: $userId }
            ) {
              id
            }
          }
        `,
        variables: {
          auditIds: this.auditIds,
          userId: this.userId,
        },
      }),
        await this.$apollo.query({
          query: gql`
            query(
              $userId: ID!
              $auditIds: [ID!]!
              $batchurl: String!
              $name: String!
              $batchId: ID!
              $auditAt: String!
            ) {
              notifyAssignmentOfUser(
                userId: $userId
                auditIds: $auditIds
                batchurl: $batchurl
                name: $name
                batchId: $batchId
                auditAt: $auditAt
              )
            }
          `,
          variables: {
            userId: this.userId,
            auditIds: this.auditIds,
            batchurl: `https://app.mnpll.com/#/reporting/batches/${this.$route.params.batchId}`,
            name: this.$moonpull.getCurrentUserSession().name,
            batchId: this.batch.id,
            auditAt: this.dateFormat(this.batch.finishedAt, "dd/mm/yy"),
          },
        });
      this.$emit("dismissModals");
      this.$store.dispatch("flashMessage", {
        type: "success",
        msg: "Assignment successful",
      });
    },

    async notifyDetails() {
      this.$apollo.mutate({
        mutation: gql`
          mutation UpdateManyAudit($auditIds: [ID!], $userId: ID) {
            auditUpdateMany(
              filter: { id: { in: $auditIds } }
              record: { assignedToId: $userId }
            ) {
              id
            }
          }
        `,
        variables: {
          auditIds: this.auditIds,
          userId: this.userId,
        },
      }),
        await this.$apollo.query({
          query: gql`
            query(
              $userId: ID!
              $auditIds: [ID!]!
              $batchurl: String!
              $name: String!
              $batchId: ID!
              $auditAt: String!
            ) {
              notifyDetails(
                userId: $userId
                auditIds: $auditIds
                batchurl: $batchurl
                name: $name
                batchId: $batchId
                auditAt: $auditAt
              )
            }
          `,
          variables: {
            userId: this.userId,
            auditIds: this.auditIds,
            batchurl: `https://app.mnpll.com/#/reporting/batches/${this.$route.params.batchId}`,
            name: this.$moonpull.getCurrentUserSession().name,
            batchId: this.batch.id,
            auditAt: this.dateFormat(this.batch.finishedAt, "dd/mm/yy"),
          },
        });
      this.$emit("dismissModals");
      this.$store.dispatch("flashMessage", {
        type: "success",
        msg: "Assignment successful",
      });
    },

    async fetchChangedAuditsCount() {
      const GET_CHANGED_AUDITS_COUNT = gql`
        query GetAuditChangeCount($batchId: ID!) {
          getAuditChangeCount(batchId: $batchId) {
            count
            isChangedFromComparison
          }
        }
      `;

      try {
        const response = await this.$apollo.query({
          query: GET_CHANGED_AUDITS_COUNT,
          variables: { batchId: this.$route.params.batchId },
        });

        // Check if response data is not null or undefined
        if (response?.data?.getAuditChangeCount) {
          this.changedCount = response.data.getAuditChangeCount.count;
          this.isAuditChanged =
            response.data.getAuditChangeCount.isChangedFromComparison;
        } else {
          // Handle case where response data is null or undefined
          this.changedCount = 0; // Set a default value
          this.isAuditChanged = false; // Set a default value
        }
      } catch (error) {
        console.error("Error fetching changed audits count:", error);
      }
    },

    generateScreenshotUrl(key) {
      return `https://d30bc2nkwjetgt.cloudfront.net/${key}`;
    },

    getCurrentScreenshot(stage) {
      const screenshot = this.auditData.screenshots.find(
        (s) => s.stage === stage
      );
      if (!screenshot) {
        return "None found";
      }
      return this.generateScreenshotUrl(screenshot.screenshotUrl);
    },

    getColorForStatus(status) {
      // Define logic to determine the color based on the status
      if (status === "IMMEDIATE") return "success-bg";
      if (status === "NO_MEMORY_COOKIE") return "danger-bg";
      if (status === "CONDITIONAL_ON_CMP") return "warning-bg";
      if (status === "CONDITIONAL_ON_CMP_AND_REFRESH") return "warning-bg";
      // Add more conditions as needed
      return "default-bg";
    },

    getReadableMemoryCookieStatus(memoryCookieStatus) {
      switch (memoryCookieStatus) {
        case "IMMEDIATE":
          return "Cookie appears immediately";
        case "CONDITIONAL_ON_CMP":
          return "Cookie on user consent";
        case "CONDITIONAL_ON_CMP_AND_REFRESH":
          return "Cookie with consent and refresh";
        case "NO_MEMORY_COOKIE":
          return "Cookie not found";
        case "CLOSED_ADVERTISER":
          return "Closed advertiser";
        case "MANUAL_REVIEW":
          return "Manual review";
        case "NOT_AUDITED":
          return "Not audited";
        case "OTHER":
          return "Other";
        default:
          return "Unknown";
      }
    },

    handleFilter(status) {
      if (!status) {
        this.memoryCookieStatuses = [];
      } else if (this.memoryCookieStatuses.includes(status)) {
        this.memoryCookieStatuses = [
          ...this.memoryCookieStatuses.filter((s) => s !== status),
        ];
      } else {
        this.memoryCookieStatuses.push(status);
      }
    },

    toggleChangedView() {
      if (this.view === null) {
        this.view = "CHANGED";
      } else {
        this.view = null;
      }
    },

    getAuditMemoryCookieStatusLabel(checkStatus) {
      if (checkStatus === "IMMEDIATE") return "badge badge-primary";
      else if (checkStatus === "CONDITIONAL_ON_CMP")
        return "badge badge-warning";
      else if (checkStatus === "CONDITIONAL_ON_CMP_AND_REFRESH")
        return "badge badge-warning";
      else if (checkStatus === "NO_MEMORY_COOKIE") return "badge badge-danger";
      else if (checkStatus === "CLOSED_ADVERTISER")
        return "badge badge-secondary";
      else if (checkStatus === "NOT_AUDITED") return "badge badge-secondary";
      else if (checkStatus === "MANUAL_REVIEW") return "badge badge-secondary";
      else if (checkStatus === "OTHER") return "badge badge-secondary";
      return "badge badge-secondary";
    },

    getErrorStatusesForStage(audit, stage) {
      const errorPrefix =
        stage === "alp"
          ? "5"
          : stage === "alp-post-consent"
          ? "6"
          : stage === "alp-post-consent-refresh"
          ? "7"
          : null;

      if (!errorPrefix || !audit.moonpullErrors) {
        return "N/A";
      }
      const networkErrors = this.networkErrorCodes.find(
        (n) => n.network === audit.network
      );
      return `
        ${
          networkErrors && networkErrors.errorCodes.includes(`${errorPrefix}.3`)
            ? audit.moonpullErrors.find(
                (e) => e.moonpullErrorId === `${errorPrefix}.3`
              )
              ? "N"
              : "OK"
            : "N/A"
        }
        <strong>${
          audit.cmpId === null && errorPrefix !== "5"
            ? "-"
            : audit.moonpullErrors.find(
                (e) => e.moonpullErrorId === `${errorPrefix}.4`
              )
            ? "N"
            : "OK"
        }</strong>
        ${
          (audit.cmpId === null && errorPrefix !== "5") ||
          audit.moonpullErrors.find(
            (e) => e.moonpullErrorId === `${errorPrefix}.4`
          )
            ? "-"
            : audit.moonpullErrors.find(
                (e) => e.moonpullErrorId === `${errorPrefix}.5`
              )
            ? "N"
            : "OK"
        }
      `;
    },

    getTrackingMatrix(audit) {
      if (
        audit.memoryCookieStatus === "MANUAL_REVIEW" ||
        audit.memoryCookieStatus === "CLOSED_ADVERTISER"
      ) {
        return ""; // Return an empty string for specified audit statuses
      }

      const stages = [
        { name: "alp", flag: "hasAlp" },
        { name: "alp-post-consent", flag: "hasAlpPostConsent" },
        { name: "alp-post-consent-refresh", flag: "hasAlpPostConsentRefresh" },
      ];

      const errorStatuses = stages.map(({ name, flag }) => {
        // Check if the audit has the stage based on the flag
        if (!audit[flag]) {
          return ""; // Skip processing if the audit does not have this stage
        }

        const errorPrefix =
          name === "alp"
            ? "5"
            : name === "alp-post-consent"
            ? "6"
            : name === "alp-post-consent-refresh"
            ? "7"
            : null;

        if (!errorPrefix || !audit.moonpullErrors) {
          return "N/A";
        }

        const networkErrors = this.networkErrorCodes.find(
          (n) => n.network === audit.network
        );
        const isErrorPresent = (errorCode) =>
          audit.moonpullErrors.find(
            (e) => e.moonpullErrorId === `${errorPrefix}.${errorCode}`
          );

        const statusForErrorCode3 =
          networkErrors && networkErrors.errorCodes.includes(`${errorPrefix}.3`)
            ? isErrorPresent("3")
              ? "N"
              : "OK"
            : "N/A";
        const statusForErrorCode4 =
          audit.cmpId === null && errorPrefix !== "5"
            ? "-"
            : isErrorPresent("4")
            ? "N"
            : "OK";
        const statusForErrorCode5 =
          (audit.cmpId === null && errorPrefix !== "5") || isErrorPresent("4")
            ? "-"
            : isErrorPresent("5")
            ? "N"
            : "OK";

        // For simplicity, this example just returns the status for error code 3.
        // Adjust your logic here if you need to check for stage applicability based on audit properties.
        return statusForErrorCode3;
      });

      // Filter out empty strings to avoid displaying them, if necessary.
      return errorStatuses.filter((status) => status !== "").join(" ");
    },

    auditUpdateMany() {
      this.$apollo.mutate({
        mutation: gql`
          mutation UpdateManyAudit($auditIds: [ID!], $userId: ID) {
            auditUpdateMany(
              filter: { id: { in: $auditIds } }
              record: { assignedToId: $userId }
            ) {
              id
            }
          }
        `,
        variables: {
          auditIds: this.auditIds,
          userId: this.userId,
        },
      });
      this.$emit("dismissModals");
    },

    rerunBatch() {
      this.$moonpull.rerunBatch(this.batch.id).then((success) => {
        if (success) {
          this.$router.push({
            name: "reporting-batches",
          });
        }
      });
    },

    userMany(gql) {
      return gql`
        query {
          userMany {
            id
            email
            name
          }
        }
      `;
    },

    statusMany(gql) {
      return gql`
        query {
          statusMany(sort: { order: ASC }) {
            id
            narrative
            statusType
          }
        }
      `;
    },

    rerunAudit(audit) {
      if (!this.awaitingSingleRerun) {
        const auditRunningFor = Date.now() - audit.auditedAt;
        if (auditRunningFor < 600000) {
          alert(
            `Please wait at least 10 mins before force-restarting a link (link has been processing for ${Math.floor(
              auditRunningFor / 1000
            )} seconds)`
          );
          return;
        }

        this.awaitingSingleRerun = true;
        audit.status = "PROCESSING";
        audit.auditedAt = Date.now();
        this.$moonpull.rerunAudit(audit.batch.id, audit.id);
      }
    },

    addComment(audit) {
      this.$apollo.mutate({
        mutation: gql`
          mutation($auditId: ID!, $clientComment: String!) {
            auditUpdateById(
              id: $auditId
              record: { clientComment: $clientComment }
            ) {
              id
            }
          }
        `,
        variables: {
          auditId: audit.id,
          clientComment: audit.clientComment,
        },
      });
      this.$emit("dismissModals");
    },

    addMoonpullComment(audit) {
      this.$apollo.mutate({
        mutation: gql`
          mutation($auditId: ID!, $moonpullComment: String!) {
            auditUpdateById(
              id: $auditId
              record: { moonpullComment: $moonpullComment }
            ) {
              id
            }
          }
        `,
        variables: {
          auditId: audit.id,
          moonpullComment: audit.moonpullComment,
        },
      });
      this.$emit("dismissModals");
    },

    downloadInputCsv() {
      if (this.batch.csv) {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display:none");
        const blob = new Blob([this.batch.csv], { type: "octet/stream" });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = `input.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },

    downloadGeneratedInputCsv() {
      this.$moonpull.downloadFile(
        "text/csv",
        "input.csv",
        this.batch.generatedInputCsv
      );
    },

    toggleDropdown(audit) {
      // Toggle all other audits dropdown off
      this.audits.items.forEach((a) => {
        if (a.id !== audit.id) {
          a.showDropdown = false;
        }
      });

      // Toggle dropdown status for this audit
      audit.showDropdown = !audit.showDropdown;

      // Hack to force rerender of array
      this.audits.items = [...this.audits.items];
    },

    toggleAllDropDownsOff() {
      // Toggle all other audits dropdown off
      this.audits.items.forEach((a) => {
        a.showDropdown = false;
      });

      // Hack to force rerender of array
      this.audits.items = [...this.audits.items];
    },

    toggleDropdown1() {
      this.showDropdown1 = !this.showDropdown1;
    },

    auditLink(audit) {
      return {
        name: "report-detail-output",
        params: {
          batchId: this.$route.params.batchId,
          auditId: audit.id,
          view: this.view,
        },
      };
    },

    getAlpDomain(audit) {
      return audit.finalDomain;
    },

    templateBatchesQuery(gql) {
      return gql`
        query TemplateBatches {
          batchMany(filter: { isTemplate: true }, sort: { startedAt: DESC }) {
            items {
              id
              name
              description
            }
          }
        }
      `;
    },

    async addLinksToTemplateBatch() {
      this.addingLinksToTemplate = true;
      await this.$apollo.mutate({
        mutation: gql`
          mutation AddLinksToTemplateBatch($batchId: ID!, $auditIds: [ID!]!) {
            addLinksToTemplateBatch(batchId: $batchId, auditIds: $auditIds)
          }
        `,
        variables: {
          batchId: this.templateBatchId,
          auditIds: this.auditIds,
        },
      });
      this.addingLinksToTemplate = false;
      this.$store.dispatch("flashMessage", {
        type: "success",
        msg: `Successfully added ${this.auditIds.length} link(s) to your template`,
      });
      this.$emit("dismissModals");
    },

    calculate2023Value(batchHealthCheck) {
      let numerator1 =
        batchHealthCheck.advertiserWithIssues /
        (batchHealthCheck.total - batchHealthCheck.processFailed);
      let numerator2 =
        (batchHealthCheck.healthyAfterAcceptAll * 0.5) /
        (batchHealthCheck.total - batchHealthCheck.processFailed);
      let numerator = 0.3 * (numerator1 + numerator2);
      let denominator = 1 - numerator;
      let result = (numerator / denominator) * 100;
      // Check for NaN or infinity
      if (isNaN(result) || !isFinite(result)) {
        return 0; // return default value or any indicative value
      }
      return Math.round(result);
    },
    calculate2024Value(batchHealthCheck) {
      let numerator1 =
        batchHealthCheck.advertiserWithIssues /
        (batchHealthCheck.total - batchHealthCheck.processFailed);
      let numerator2 =
        (batchHealthCheck.healthyAfterAcceptAll * 0.5) /
        (batchHealthCheck.total - batchHealthCheck.processFailed);
      let numerator = numerator1 + numerator2;
      let denominator = 1 - numerator;
      let result = (numerator / denominator) * 100;
      // Check for NaN or infinity
      if (isNaN(result) || !isFinite(result)) {
        return 0; // return default value or any indicative value
      }
      return Math.round(result);
    },

    async deleteAuditAndBatchLink(audit) {
      if (
        confirm(
          "This will permanently delete the audit and prevent it from rerunning as part of this batch in the future. Are you sure?"
        )
      ) {
        await this.$apollo.mutate({
          mutation: gql`
            mutation DeleteBatchLink($auditId: ID!) {
              batchLinkDeleteByAuditId(auditId: $auditId)
            }
          `,
          variables: {
            auditId: audit.id,
          },
        });
        await this.$apollo.mutate({
          mutation: gql`
            mutation DeleteAudit($id: ID!) {
              auditDeleteById(id: $id)
            }
          `,
          variables: {
            id: audit.id,
          },
        });
        this.$apollo.queries.audits.refetch();
      }
    },

    async moveAuditAndBatchLink(audit) {
      if (
        confirm(
          "This will permanently move this audit to a different batch. The destination batch will run this audit as part of its reruns in the future. Are you sure?"
        )
      ) {
        this.movingAudit = true;
        await this.$apollo.mutate({
          mutation: gql`
            mutation MoveAudit($auditId: ID!, $moveToBatchId: ID!) {
              moveAudit(auditId: $auditId, moveToBatchId: $moveToBatchId)
            }
          `,
          variables: {
            auditId: audit.id,
            moveToBatchId: this.selectedMoveBatch,
          },
        });
        this.selectedMoveBatch = null;
        this.movingAudit = false;
        this.$apollo.queries.audits.refetch();
      }
    },

    getBatchesForBatchMoveDropdown() {
      return gql`
        query {
          batchMany(page: 1, perPage: 100, sort: { startedAt: DESC }) {
            items {
              id
              name
              description
              startedAt
            }
          }
        }
      `;
    },
    fetchBatches() {
      this.$apollo
        .query({
          query: BATCHES_QUERY, // use your existing gql query
          variables: this.batches.variables(),
        })
        .then(({ data }) => {
          // Process the fetched data
          this.processedBatches = data.batchMany.items; // Adjust according to your needs
        })
        .catch((error) => {
          // Error handling
          console.error(error);
        });
    },
    openMoveAuditModal() {
      this.isModalOpen = true;
      this.fetchBatches(); // Fetch batches when the modal opens
      // ... any other logic for opening the modal
    },

    closeMoveAuditModal() {
      this.isModalOpen = false;
      this.processedBatches = []; // Reset the batches data
      // ... any other logic for closing the modal
    },

    updateFilterString(newFilter) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.batchFilterString = newFilter;
      }, 500); // Adjust delay as needed
    },

    shouldShowWhitelist(audit) {
      if (audit.advertiser?.whitelistRequest) {
        return false;
      }
      if (audit.countryCode.toLowerCase() === "uk") {
        return true;
      }
      return this.dataCentres.some(
        (dc) => dc.code === audit.countryCode.toLowerCase()
      );
    },

    async softDeleteAudit(audit) {
      if (confirm("Are you sure you want to remove this in-progress audit?")) {
        await this.$apollo.mutate({
          mutation: gql`
            mutation AuditSoftDeleteById($id: ID!) {
              auditSoftDeleteById(id: $id)
            }
          `,
          variables: {
            id: audit.id,
          },
        });
        this.$store.dispatch("flashMessage", {
          type: "success",
          msg: `Successfully deleted audit`,
        });
        this.$apollo.queries.audits.refetch();
      }
    },

    async batchCleanup() {
      const batchCleanupInfo =
        `The batch cleanup process will remove audits that:\r\n` +
        `a) Have already had their link audited successfully\r\n` +
        `AND b) Are stuck in "processing" OR have failed without being superseded.\r\n` +
        `This action is irreversible. Do you wish to continue?`;
      if (confirm(batchCleanupInfo)) {
        this.cleaningUp = true;
        await this.$apollo.mutate({
          mutation: gql`
            mutation BatchCleanup($batchId: ID!) {
              batchCleanup(id: $batchId)
            }
          `,
          variables: {
            batchId: this.$route.params.batchId,
          },
        });
        this.$router.go();
      }
    },

    auditHasCmp(audit) {
      return (
        !!audit.detectedCmp || !!audit.cmpVendor || !!audit.liteResult?.cmp
      );
    },

    getScriptStatus(auditId) {
      const script = this.liteScripts.find(
        (script) => script.auditId === auditId
      );
      if (!script) return "N";

      const {
        masterTagAlp,
        masterTagAlpPostConsent,
        masterTagAlpPostConsentRefresh,
      } = script;

      if (!masterTagAlp) {
        return "N";
      }

      const statuses = [
        masterTagAlp ? "OK" : "N",
        masterTagAlpPostConsent ? "OK" : "N",
        masterTagAlpPostConsentRefresh ? "OK" : "N",
      ];

      return statuses.join(" ");
    },

    getDeltaClass(row) {
      const negativeStatuses = ['NO_MEMORY_COOKIE', 'MANUAL_REVIEW', 'NOT_AUDITED', 'CLOSED_ADVERTISER'];
      const isNegativeStatus = negativeStatuses.includes(row.status);
      if (isNegativeStatus) {
        return row.delta < 0 ? 'delta-positive' : 'delta-negative';
      }
      return row.delta > 0 ? 'delta-positive' : 'delta-negative';
    },

    async fetchHistoricalBatchStatusCounts(batchId) {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query HistoricalMemoryCookieStatusCounts($batchId: ID!, $countPlatformResultsOnly: Boolean!) {
              memoryCookieStatusCounts(batchId: $batchId, countPlatformResultsOnly: $countPlatformResultsOnly) {
                status
                statusReadable
                count
              }
            }
          `,
          variables: {
            batchId,
            countPlatformResultsOnly: this.showOnlyPlatformResults,
          },
        });
        this.historicalBatchStatusCounts = data.memoryCookieStatusCounts;
      } catch (e) {
        console.error('Failed to fetch historical batch status counts', e);
        this.historicalBatchStatusCounts = null;
      }
    },

    async performAiQuestionsAndActions() {
      try {
        await api('POST', `/gemini/ai-questions/batches/${this.$route.params.batchId}`)
        this.$store.dispatch('flashMessage', { type: 'success', msg: 'AI is now running. Please check back later.' })
        this.batch.isAiProcessing = true
      } catch (e) {
        console.error(`Failed to perform ai questions and actions on batch`, e)
        this.$store.dispatch('flashMessage', { type: 'danger', msg: 'Failed to perform AI Questions on Batch. Please try again later.' })
      }
    },
  },

  async beforeCreate() {
    await this.$moonpull.redirectToNewBatchIdIfNecessary(
      this.$route.params.batchId
    );
    await this.fetchChangedAuditsCount();
  },

  async mounted() {
    this.view = this.$route.query.view || null;
    this.platformContent = await this.$moonpull.getPlatformContent();
    this.networks = await this.$moonpull.getNetworks();
    this.networkErrorCodes = this.networks.map((network) => {
      const errorCodes = [];
      const stages = [
        "niu",
        "nir",
        "air",
        "alp",
        "alp-post-consent",
        "alp-post-consent-refresh",
      ];
      stages.forEach((stage) => {
        if (network.successCriteria[stage]) {
          if (network.successCriteria[stage].query) {
            errorCodes.push(
              ...network.successCriteria[stage].query
                .map((q) => [
                  q.moonpullErrorCodeForKey,
                  q.moonpullErrorCodeForValue,
                ])
                .flat()
            );
          }
          if (network.successCriteria[stage].cookies) {
            errorCodes.push(
              ...network.successCriteria[stage].cookies
                .map((q) => [
                  q.moonpullErrorCodeForKey,
                  q.moonpullErrorCodeForValue,
                ])
                .flat()
            );
          }
          if (network.successCriteria[stage].scripts) {
            errorCodes.push(
              ...network.successCriteria[stage].scripts.map(
                (q) => q.moonpullErrorCode
              )
            );
          }
          if (network.successCriteria[stage].extracted) {
            errorCodes.push(
              ...network.successCriteria[stage].extracted.map(
                (q) => q.moonpullErrorCode
              )
            );
          }
        }
      });
      return {
        network: network.name,
        errorCodes,
      };
    });

    this.loading = false;
  },
});
</script>
